import { lazy } from "react";

export const ItemPost = lazy(() => import("./ItemPost"));
